// Module
var code = "<script>let $ctrl</script> <div class=\"molecule-creating-overlay\" ng-if=\"$ctrl.visible\"> <div class=\"molecule-creating-overlay__content\"> <fa-icon icon=\"spinner\" spin=\"true\"></fa-icon> <atom-text modifier=\"subheadline\">{{ $ctrl.text }}</atom-text> </div> </div> ";
// Exports
module.exports = code;